import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=affcff68&scoped=true&"
import script from "./AdminUsers.vue?vue&type=script&lang=ts&"
export * from "./AdminUsers.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=affcff68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affcff68",
  null
  
)

export default component.exports